import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { limitOrderReferentialSelectors } from 'state/secondaryMarket/limit-order/referential/referential.selector';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
}>;

type StateProps = Readonly<{
  salesMessage: string | undefined;
  traderMessage: string | undefined;
}>;

export type MessagesProps = OwnProps & StateProps;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (state, { tabId }) => {
  return {
    salesMessage: limitOrderReferentialSelectors.getSalesMessage(state, tabId),
    traderMessage: limitOrderReferentialSelectors.getTraderMessage(state, tabId),
  };
};

export const connectLimitOrderMessages = connect(mapStateToProps);
